import React from "react";
import LoadMask from "Utils/LoadMask/LoadMask";
import { useTrasladoForm } from "../hooks/useTrasladoForm";
import { EncabezadoTraslado } from "./EncabezadoTraslado";
import { TrasladoTable } from "./TrasladoTable";
import { TrasladoSobranteTable } from "./TrasladoSobranteTable";
import { ResumenTraslado } from "./ResumenTraslado";
import { AvisoPalletsIngresadosDespues } from "../../../../components/AvisoPalletsIngresadosDespues";

export const CreacionTrasladoForm = ({
    regresar,
    navigateToBoleta,
    nombreUsuario,
}) => {
    const trasladoForm = useTrasladoForm(navigateToBoleta);

    const { destinoTraslado, palletsOcultos, cargando, FormSubmit } =
        trasladoForm;

    let tblContent = null;
    if (destinoTraslado) {
        tblContent = (
            <React.Fragment>
                <AvisoPalletsIngresadosDespues pallets={palletsOcultos} />
                <TrasladoTable trasladoForm={trasladoForm} />
                <TrasladoSobranteTable trasladoForm={trasladoForm} />
                <ResumenTraslado trasladoForm={trasladoForm} />
            </React.Fragment>
        );
    } else {
        tblContent = (
            <h5 className="text-center my-5">
                Seleccione un tipo de traslado para ver las existencias
                disponibles
            </h5>
        );
    }

    return (
        <LoadMask loading={cargando} blur>
            <h4 className="mb-3">Detalle de traslado</h4>

            <EncabezadoTraslado
                trasladoForm={trasladoForm}
                nombreUsuario={nombreUsuario}
            />

            {tblContent}

            <div className="d-flex justify-content-center mt-5 gap-1rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                {destinoTraslado && (
                    <button
                        className="btn btn-primary"
                        onClick={FormSubmit}
                        disabled={cargando}
                    >
                        Guardar e imprimir
                    </button>
                )}
            </div>
        </LoadMask>
    );
};
